export default __webpack_public_path__ + "ded340d981a5a0801fa958565c38be88.png";